/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function StoreHeader() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const handleChangeLang = (lang: string) => {
        i18n.changeLanguage(lang);
        if (lang === "ar" || lang === "ur") {
            document.documentElement.dir = "rtl";
        } else {
            document.documentElement.dir = "ltr";
        }
    };
    const appStoreURL = "https://apps.apple.com/ae/app/z-shops/id6475626069";
    const playStoreURL =
        "https://play.google.com/store/apps/details?id=com.zabehatyshopapp";
    const banners = [
        "/store/background_image/background_image1.jpg",
        "/store/background_image/background_image2.jpg",
    ];
    const [activeBanner, setActiveBanner] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveBanner((prev) => (prev + 1) % banners.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <header className="absolute left-0 top-8 z-50 flex w-full items-center justify-between px-8">
                <img
                    src="/store/store_logos/logo1.svg"
                    alt="Logo 1"
                    className="h-24 object-contain"
                />
                <div className="hidden space-x-8 md:flex rtl:space-x-reverse">
                    <a
                        href="/store"
                        className="text-lg text-white underline hover:underline"
                    >
                        {t("home")}
                    </a>
                    <div className="group relative">
                        <button className="text-lg text-white hover:underline">
                            {t("language")}
                        </button>
                        <div
                            className="invisible absolute left-0 mt-2 w-[240px] bg-white p-4
                            opacity-0 shadow-lg transition-all duration-200
                            group-hover:visible group-hover:opacity-100"
                        >
                            <button
                                onClick={() => handleChangeLang("ar")}
                                className="block w-full px-4 py-2 text-left text-lg text-black hover:bg-[#01E784] hover:text-white"
                            >
                                العربية
                            </button>
                            <button
                                onClick={() => handleChangeLang("en")}
                                className="block w-full px-4 py-2 text-left text-lg text-black hover:bg-[#01E784] hover:text-white"
                            >
                                English
                            </button>
                            <button
                                onClick={() => handleChangeLang("ur")}
                                className="block w-full px-4 py-2 text-left text-lg text-black hover:bg-[#01E784] hover:text-white"
                            >
                                اردو
                            </button>
                        </div>
                    </div>

                    <a
                        href="/store/register"
                        className="text-lg text-white hover:underline"
                    >
                        {t("register-store")}
                    </a>
                    <a
                        href="/store/articles"
                        className="text-lg text-white hover:underline"
                    >
                        {t("article")}
                    </a>
                </div>
                <div className="hidden flex-row items-center rounded px-6 py-3 font-semibold text-white transition md:flex space-x-4 rtl:space-x-reverse">
                    <a
                        href={appStoreURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative inline-block"
                    >
                        <img
                            src="/store/logos/appstore_icon.svg"
                            alt="App Store"
                            className="m-0 object-contain p-0 transition-opacity duration-300 group-hover:opacity-0"
                        />
                        <img
                            src="/store/logos/appstore_hovericon.svg"
                            alt="App Store Hover"
                            className="absolute inset-0 m-0 object-contain p-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                        />
                    </a>
                    <a
                        href={playStoreURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative inline-block"
                    >
                        <img
                            src="/store/logos/playstore_icon.svg"
                            alt="Play Store"
                            className="m-0 object-contain p-0 transition-opacity duration-300 group-hover:opacity-0"
                        />
                        <img
                            src="/store/logos/playstore_hovericon.svg"
                            alt="Play Store Hover"
                            className="absolute inset-0 m-0 object-contain p-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                        />
                    </a>
                </div>
                <div className="md:hidden">
                    <button
                        onClick={() => setMobileOpen(true)}
                        className="text-2xl text-white"
                    >
                        ☰
                    </button>
                </div>
            </header>
            <section
                className="relative flex flex-col items-center justify-center text-white"
                style={{
                    backgroundImage: `url('${banners[activeBanner]}')`,
                    height: "1000px",
                    width: "100%",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-30"></div>
                <img
                    src="/store/background_image/landingpage_bannercenter1.svg"
                    alt="Zabehaty"
                    className="relative z-10 h-auto w-3/4 sm:w-1/2 lg:w-2/5"
                />
                <div className="font-lighter relative z-10 my-6 text-center text-lg">
                    <p className="text-white">{t("meat-grocery-delivery")}</p>
                </div>
                <a
                    href="/store/register"
                    className="group relative mt-4 overflow-hidden bg-[#01E784] px-6 py-3 font-semibold 
             text-white transition-colors duration-300"
                >
                    <span className="relative z-10 transition-colors duration-300 group-hover:text-[#01E784]">
                        {t("register")}
                    </span>
                    <span
                        className="absolute left-1/2 top-1/2 h-0 w-0 -translate-x-1/2 -translate-y-1/2 
               rounded-full bg-black transition-all
               duration-500 ease-out 
               group-hover:h-[500px] group-hover:w-[500px]"
                    ></span>
                </a>
                <div className="absolute bottom-8 z-10 flex w-full items-center justify-between px-8">
                    <div className="flex items-center">
                        {banners.map((_, idx) => (
                            <button
                                key={idx}
                                onClick={() => setActiveBanner(idx)}
                                className={`
                                    relative flex h-[2rem] w-[2rem] scale-100 items-center justify-center
                                    rounded-full transition-all duration-300
                                `}
                            >
                                {idx === activeBanner && (
                                    <span className="absolute inset-0 rounded-full border border-white bg-white/30" />
                                )}
                                <span className="h-[0.8rem] w-[0.8rem] rounded-full bg-white" />
                            </button>
                        ))}
                    </div>
                    <div className="flex items-center space-x-6">
                        <img
                            src="/store/store_logos/logo1.svg"
                            alt="Logo 1"
                            className="h-20 object-contain transition-transform duration-200 hover:scale-110"
                        />
                        <img
                            src="/store/store_logos/logo2.svg"
                            alt="Logo 2"
                            className="h-20 object-contain transition-transform duration-200 hover:scale-110"
                        />
                    </div>
                    <a
                        href="https://wa.me/971509681814"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-transform duration-200 hover:scale-110"
                    >
                        <img
                            src="/landingpage_whatsappicon.svg"
                            alt="WhatsApp"
                            className="h-14 w-14 rounded-full shadow-lg"
                        />
                    </a>
                </div>
            </section>
            {mobileOpen && (
                <div className="fixed inset-0 z-[9999] flex flex-col space-y-6 bg-white p-8 text-black">
                    <button
                        onClick={() => setMobileOpen(false)}
                        className="self-end text-3xl"
                    >
                        ✕
                    </button>

                    <a
                        href="/store"
                        onClick={() => setMobileOpen(false)}
                        className="font-semibold"
                    >
                        {t("home")}
                    </a>
                    <div>
                        <div className="mb-2 font-bold">{t("language")}</div>
                        <div className="flex flex-col space-y-2">
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMobileOpen(false);
                                    handleChangeLang("ar");
                                }}
                            >
                                العربية
                            </a>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMobileOpen(false);
                                    handleChangeLang("en");
                                }}
                            >
                                English
                            </a>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMobileOpen(false);
                                    handleChangeLang("ur");
                                }}
                            >
                                اردو
                            </a>
                        </div>
                    </div>

                    <a
                        href="/store/register"
                        onClick={() => setMobileOpen(false)}
                        className="font-semibold"
                    >
                        Register Store
                    </a>

                    <div className="hidden flex-row items-center rounded px-6 py-3 font-semibold text-white transition md:flex">
                        <svg
                            className="transition ease-in-out hover:scale-110"
                            width="55"
                            height="55"
                            viewBox="0 0 68 68"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <foreignObject
                                x="-7.04654"
                                y="-11.0485"
                                width="82.1009"
                                height="82.1009"
                            >
                                <div
                                    // eslint-disable-next-line react/style-prop-object
                                    style={{
                                        backdropFilter: "blur(5.53px)",
                                        clipPath:
                                            "url(#bgblur_0_350_1470_clip_path)",
                                        height: "100%",
                                        width: "100%",
                                    }}
                                ></div>
                            </foreignObject>
                            <g
                                filter="url(#filter0_d_350_1470)"
                                data-figma-bg-blur-radius="11.0504"
                            >
                                <rect
                                    x="4.00391"
                                    y="0.00195312"
                                    width="60"
                                    height="60"
                                    fill="white"
                                    fill-opacity="0.1"
                                    shape-rendering="crispEdges"
                                />
                                <rect
                                    x="4.50391"
                                    y="0.501953"
                                    width="59"
                                    height="59"
                                    stroke="white"
                                    shape-rendering="crispEdges"
                                />
                                <g clip-path="url(#clip1_350_1470)">
                                    <path
                                        d="M38.7895 18.0662C38.6231 17.4456 38.2252 16.9269 37.6688 16.6057C36.5205 15.9426 35.0465 16.3374 34.3833 17.4861L34.0131 18.1273L33.6428 17.486C32.9797 16.3376 31.5058 15.9426 30.3573 16.6056C29.2087 17.2688 28.8138 18.7426 29.4769 19.8913L31.2357 22.9376L24.746 34.1782H20.0146C18.6884 34.1782 17.6094 35.2572 17.6094 36.5835C17.6094 37.9097 18.6884 38.9887 20.0146 38.9887H38.2809L35.5035 34.1782H30.3006L38.5491 19.8914C38.8704 19.335 38.9558 18.6867 38.7895 18.0662Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M48.0124 34.1781H43.281L37.9023 24.8618L35.125 29.6723L43.4763 44.1371C43.7976 44.6936 44.3162 45.0916 44.9369 45.258C45.1441 45.3135 45.3544 45.341 45.5633 45.341C45.9801 45.341 46.3915 45.2317 46.7622 45.0177C47.9107 44.3545 48.3056 42.8806 47.6424 41.7321L46.0583 38.9886H48.0124C49.3387 38.9886 50.4177 37.9096 50.4177 36.5834C50.4177 35.2571 49.3387 34.1781 48.0124 34.1781Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M20.8572 40.9128L20.3842 41.732C19.7212 42.8804 20.1161 44.3541 21.2644 45.017C21.6422 45.2351 22.0551 45.3388 22.4628 45.3387C23.2945 45.3387 24.1046 44.9074 24.5496 44.1368L26.4109 40.9128H20.8572Z"
                                        fill="white"
                                    />
                                </g>
                            </g>
                            <defs>
                                <filter
                                    id="filter0_d_350_1470"
                                    x="-7.04654"
                                    y="-11.0485"
                                    width="82.1009"
                                    height="82.1009"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                    />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite
                                        in2="hardAlpha"
                                        operator="out"
                                    />
                                    <feColorMatrix
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in2="BackgroundImageFix"
                                        result="effect1_dropShadow_350_1470"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_dropShadow_350_1470"
                                        result="shape"
                                    />
                                </filter>
                                <clipPath
                                    id="bgblur_0_350_1470_clip_path"
                                    transform="translate(7.04654 11.0485)"
                                >
                                    <rect
                                        x="4.00391"
                                        y="0.00195312"
                                        width="60"
                                        height="60"
                                    />
                                </clipPath>
                                <clipPath id="clip1_350_1470">
                                    <rect
                                        width="33.8146"
                                        height="33.8146"
                                        fill="white"
                                        transform="translate(17.1094 13.9043)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <svg
                            className="transition ease-in-out hover:scale-110"
                            width="55"
                            height="55"
                            viewBox="0 0 68 68"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <foreignObject
                                x="-7.26205"
                                y="-11.2621"
                                width="82.528"
                                height="82.528"
                            >
                                <div
                                    // eslint-disable-next-line react/style-prop-object
                                    style={{
                                        backdropFilter: "blur(5.63px)",
                                        clipPath:
                                            "url(#bgblur_0_350_1471_clip_path)",
                                        height: "100%",
                                        width: "100%",
                                    }}
                                ></div>
                            </foreignObject>
                            <g
                                filter="url(#filter0_d_350_1471)"
                                data-figma-bg-blur-radius="11.266"
                            >
                                <rect
                                    x="4.00391"
                                    y="0.00390625"
                                    width="59.9961"
                                    height="59.9961"
                                    fill="white"
                                    fill-opacity="0.1"
                                    shape-rendering="crispEdges"
                                />
                                <rect
                                    x="4.50391"
                                    y="0.503906"
                                    width="58.9961"
                                    height="58.9961"
                                    stroke="white"
                                    shape-rendering="crispEdges"
                                />
                                <g clip-path="url(#clip1_350_1471)">
                                    <path
                                        d="M19.9165 15.4465C19.5084 15.9858 19.2812 16.6492 19.2812 17.3592V45.4597C19.2812 46.1191 19.4779 46.7386 19.8332 47.2561L35.1229 31.3079L19.9165 15.4465Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M36.52 29.8475L41.4802 24.6738L24.0445 14.6074C23.2878 14.1704 22.4195 14.0668 21.6094 14.2945L36.52 29.8475Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M36.5222 32.7683L21.4609 48.4783C21.7857 48.5874 22.1217 48.6423 22.458 48.6423C23.0036 48.6423 23.5495 48.4988 24.0467 48.2116L41.6078 38.0727L36.5222 32.7683Z"
                                        fill="white"
                                    />
                                    <path
                                        d="M48.3819 28.6577L43.2844 25.7146L37.9219 31.3077L43.4095 37.032L48.3819 34.1612C49.3768 33.5869 49.9708 32.558 49.9708 31.4095C49.9708 30.2607 49.3768 29.232 48.3819 28.6577Z"
                                        fill="white"
                                    />
                                </g>
                            </g>
                            <defs>
                                <filter
                                    id="filter0_d_350_1471"
                                    x="-7.26205"
                                    y="-11.2621"
                                    width="82.528"
                                    height="82.528"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                    />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite
                                        in2="hardAlpha"
                                        operator="out"
                                    />
                                    <feColorMatrix
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in2="BackgroundImageFix"
                                        result="effect1_dropShadow_350_1471"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_dropShadow_350_1471"
                                        result="shape"
                                    />
                                </filter>
                                <clipPath
                                    id="bgblur_0_350_1471_clip_path"
                                    transform="translate(7.26205 11.2621)"
                                >
                                    <rect
                                        x="4.00391"
                                        y="0.00390625"
                                        width="59.9961"
                                        height="59.9961"
                                    />
                                </clipPath>
                                <clipPath id="clip1_350_1471">
                                    <rect
                                        width="34.3975"
                                        height="34.4648"
                                        fill="white"
                                        transform="translate(17.3633 14.1772)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            )}
        </>
    );
}
